import { render, staticRenderFns } from "./userSelect.vue?vue&type=template&id=2448c366&scoped=true"
import script from "./userSelect.vue?vue&type=script&lang=js"
export * from "./userSelect.vue?vue&type=script&lang=js"
import style0 from "./userSelect.vue?vue&type=style&index=0&id=2448c366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448c366",
  null
  
)

export default component.exports